// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh2[data-v-b0a06aea] {\n  font-size: 1.2rem;\n}\n", "",{"version":3,"sources":["webpack://./resources/js/Components/Rfp/RfpMeasures.vue"],"names":[],"mappings":";AAiEA;EACE,iBAAiB;AACnB","sourcesContent":["\nh2 {\n  font-size: 1.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
